export default __webpack_public_path__ + "static/media/pic4.71fba61d.jpg";